import styled from 'styled-components';

export const StyledNameFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  #base-input-field-container {
    margin: ${({ theme }) => `${theme.spacing['2Xl']} 0`};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
`;
